import abstractModel from '../../../core/MercatelyModel';
import { MERCATELY_API } from '../../../constants/AppConstants';

const resource = `${MERCATELY_API}/customer_related_fields`;

const model = abstractModel(resource);

model.getFields = async (params) => model.get(params, { path: resource });

model.delete = async (params) => model.remove(params, { path: resource });

export default model;
